<template>
    <header :class="$attrs.class">
        <div class="mx-auto font-inter legacy-md:w-full">
            <div
                class="relative flex items-center justify-between"
                :class="{ 'h-16 border-b border-ds-primary-200': portal === 'employee' }"
            >
                <div class="mx-2 flex-none overflow-hidden legacy-md:w-auto">
                    <a
                        v-if="portal === 'customer'"
                        :aria-label="isLoginProcessRoute ? 'Login' : 'Home'"
                        :href="homeLink"
                    >
                        <div class="hidden w-full py-4 pl-3 pr-2 legacy-md:block">
                            <ClosinglockLogo
                                :height="38"
                                :width="152"
                            />
                        </div>
                        <div class="mt-1 w-full py-5 pr-2 legacy-md:hidden">
                            <ClosinglockLogo />
                        </div>
                    </a>
                    <RouterLink
                        v-else-if="portal === 'employee'"
                        aria-label="Accounts"
                        :to="homeLink"
                    >
                        <ClosinglockEmployeeLogo />
                    </RouterLink>
                </div>
                <ShadowButton :portal />
                <slot name="navigation"></slot>
            </div>
        </div>
    </header>
    <ShadowWarning :portal />
</template>

<script setup lang="ts">
import ClosinglockEmployeeLogo from '@/components/Icons/ClosinglockEmployeeLogo.vue';
import ClosinglockLogo from '@/components/Icons/ClosinglockLogo.vue';
import ShadowButton from '@/components/Navigation/top-nav/ShadowButton.vue';
import ShadowWarning from '@/components/Navigation/top-nav/ShadowWarning.vue';
import { useIsLoginProcessRoute } from '@/shared/utils/login-process-route';
import { computed } from 'vue';

export interface ClosinglockHeaderProps {
    portal?: 'employee' | 'customer';
}

const props = withDefaults(defineProps<ClosinglockHeaderProps>(), {
    portal: 'employee',
});

defineSlots<{
    csrfField(): void;
    navigation(): void;
}>();

const isLoginProcessRoute = useIsLoginProcessRoute();

const homeLink = computed(() => {
    if (props.portal === 'customer') {
        return isLoginProcessRoute.value ? '/login' : '/user/home';
    }
    return '/accounts';
});
</script>
